<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="message-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
                Message us
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">
            <!-- Message hasn't been sent -->
            <template v-if="!messageSent">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(onSubmit)">

                        <div class="form-group">
                            <ValidationProvider name="Full name" rules="required" v-slot="{ errors }">
                                <label>Full name <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="contactDetail['name']" type="text" :class="{'is-invalid': errors[0]}">
                                <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
                                <label>Email address <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="contactDetail['email']" type="email" :class="{'is-invalid': errors[0]}">
                                <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <ValidationProvider name="Telephone number" rules="required" v-slot="{ errors }">
                                <label>Telephone number <span class="text-danger">*</span></label>
                                <input class="form-control" v-model="contactDetail['phonenumber']" type="tel" :class="{'is-invalid': errors[0]}">
                                <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <ValidationProvider name="Reason" rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Reason for your email <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="contactDetail['reason']" :class="{'is-invalid': errors[0]}">
                                        <option value="" disabled>Please Select</option>
                                        <option :value="reason.id" v-for="(reason, index) in contactReasons" :key="index">{{ reason.title }}</option>
                                    </select>
                                    <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="form-group">
                            <ValidationProvider name="Message" rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Message <span class="text-danger">*</span></label>
                                    <textarea id="message" class="form-control" v-model="contactDetail['message']" :class="{'is-invalid': errors[0]}"></textarea>
                                    <p class="help-block text-danger text-sm">{{ errors[0] }}</p>
                                </div>
                            </ValidationProvider>
                        </div>


                        <button class="btn btn-block continue-btn btn-lg" type="submit" v-if="!messageSending">Send message</button>
                        <button class="btn btn-block continue-btn btn-lg" v-if="messageSending" disabled><animated-loading size="xs" class="mr-1"></animated-loading> Sending message...</button>
                    </form>
                </ValidationObserver>
            </template>
            <!-- Message has been sent -->
            <template v-if="messageSent">
                <empty-state
                    class="pt-0"
                    statusIcon="success"
                    title="Thank you for your message"
                    subtitle="A member of the Likewize Repair team will contact you within 48 hours"
                ></empty-state>
                <div class="btn btn-secondary btn-block" @click="closeMessageModal()">Close</div>
            </template>
        </div>
    </b-modal>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import { extend } from 'vee-validate';

extend('required', {
    validate (value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true
});

export default {
    name: "MessageModal",

    data() {
        return {
            contactDetail: {
                email: null,
                message: null,
                name: null,
                phonenumber: null,
                reason: "",
            },
            messageSending: false,
            messageSent: false
        }
    },

    mounted() {
        this.retrieveContactReasons();
    },

    created() {
        this.grecaptcha = document.createElement('script');
        this.grecaptcha.setAttribute('src',"https://www.google.com/recaptcha/api.js?render=6Le8gt4ZAAAAANxXKPLnpqDPYwzYjcsIXDMsj-oH");
        document.head.appendChild(this.grecaptcha);
    },

    computed: {
        ...mapGetters([
            'contactReasons',
            'carrier'
        ])
    },

    methods: {
        ...mapActions([
            'retrieveContactReasons',
            'sendMessage'
        ]),

        /** Close the modal and clear the fields */
        closeMessageModal() {
            this.$bvModal.hide('message-modal')
            setTimeout(() => {
                this.messageSent = false;
                this.contactDetail.name = null;
                this.contactDetail.email = null;
                this.contactDetail.phonenumber = null;
                this.contactDetail.reason = null;
                this.contactDetail.message = null;
            }, 200)
        },

        /** Send the message */
        onSubmit() {
            this.messageSent = false;
            this.messageSending = true;

            let self = this;

            event.preventDefault();
            window.grecaptcha.ready(function() {
                window.grecaptcha.execute('6Le8gt4ZAAAAANxXKPLnpqDPYwzYjcsIXDMsj-oH', {action: 'send_message'}).then((token) => {
                    self.sendMessage({
                        name: self.contactDetail.name,
                        email: self.contactDetail.email,
                        phone: self.contactDetail.phonenumber,
                        reason: self.contactDetail.reason,
                        message: self.contactDetail.message,
                        token: token,
                        carrier: self.carrier
                    }).then(() => {
                        self.messageSent = true;
                        self.messageSending = false;
                    }).catch(() => {
                        self.messageSent = false;
                        self.messageSending = false;
                    })
                })
            })
        }
    }
}
</script>

<style scoped>

</style>